import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface ParametrosGenerales {
  afipImporteMaximoDigital: number;
  afipImporteMaximoEfectivo: number;
  horaMantenimientoServidorInicio: string;
  horaMantenimientoServidorFin: string;
  importeMinimoPermitido: number;
  cajaMovimientoTipos: [];
  comprobantesCondicionVenta: [];
  clienteTipos: [];
}

export interface ObtenerParametrosGenerales extends ResponseMessageWithInternalStatus{
  parametrosGenerales: {
    afipImporteMaximoDigital: number;
    afipImporteMaximoEfectivo: number;
    horaMantenimientoServidorInicio: string;
    horaMantenimientoServidorFin: string;
    importeMinimoPermitido: number;
    cajaMovimientoTipos: [];
    comprobantesCondicionVenta: [];
    clienteTipos: [];
  }
}

export interface ParametrosGeneralesState {
  parametrosGenerales: ParametrosGenerales | null;
  error: boolean;
  debugMessage?: any;
}

export const initialParametrosGeneralesState: ParametrosGeneralesState = {
  parametrosGenerales: null,
  error: false,
  debugMessage: null
}; 
